import "babel-polyfill";
// import "./utils/jweixin";
import "./utils/weixinJsSdk";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "mobx-react";
import "foui";
import "./utils/foStorage";
import App from "./App";
// import { enableScrollFix } from "./utils/scrollFix";
import "./styles/index.scss";
import storeLogin from "./store/storeLogin";
import utils from "./utils/utils";
// import bridgeInit from "./utils/bridge/bridgeInit";
import debugTools from "./utils/debugTools";
import weixinJsSdk from "./utils/weixinJsSdk";
import storeMine from "./store/storeMine";
// import zhugeio from "./utils/zhugeio";
import storePlayerStatistics from "./store/storePlayerStatistics";
// import Raven from "raven-js";

// import registerServiceWorker from './registerServiceWorker';
// Raven.config(
//   "https://5b1c0ac3e2bd4b899778477beb56b732@sentry.foschool.cn/3"
// ).install();

debugTools.onReady(async () => {
  try {
    await weixinJsSdk.setDefaultShare();
  } catch (err) {
    console.log(err);
  }
  // bridgeInit();
  // zhugeio.init();
  storeLogin.syncTokenFromApp();
  storeMine.initUserProfile();
  storePlayerStatistics.initStatistics();

  // enableScrollFix();

  ReactDOM.render(
    <Provider store>
      <App />
    </Provider>,
    document.getElementById("fo-app-root")
  );

  // registerServiceWorker();
});



// WEBPACK FOOTER //
// ./src/index.js